/// <reference path="./../Container/List/List.ts" />
namespace HA.Core.HTML.Form {
    export class Form extends List {

        public getTagName(): string {
            return "form";
        }

    }
}
